import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import TitleText from '../common/TitleText';
import { API_URL } from '../common/Constants';

import axios from 'axios';

const Accordion = withStyles({
  root: {
    borderBottom: '1px solid #f1f1f1',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles((theme) => ({
  root: {
    borderBottom: '1px solid #f1f1f1',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
      color: theme.palette.primary.point,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
}))(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: 'rgba(241, 241, 241,0.3)',
  },
}))(MuiAccordionDetails);

const styles = (theme) => ({
  bg: {
    width: '100%',
    // display: 'flex',
    // height: 'calc(100vh - 350px)',
    overflowX: 'hidden',
    overflowY: 'auto',
    flexDirection: 'column',
    backgroundColor: '#fafafa',
  },
  content_bg: {
    backgroundColor: '#ffffff',
    margin: '4vh auto',
    width: '100%',
    borderRadius: '20px',
  },
  titleTxt: {
    borderBottom: `3px solid ${theme.palette.primary.point}`,
    fontSize: 30,
    paddingBottom: 10,
  },
  listItem: {
    fontWeight: 'bold',
  },
  faqOuter: {
    paddingBottom: 100,
    minHeight: '45vh',
  },
});

class Faq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      now: new Date(),
      matches: window.matchMedia('(max-width:600px)').matches,
      noticeData: [],
    };
  }

  componentDidMount() {
    axios
      .get(`${API_URL}/bbs/faq/list`, {
        headers: { Pragma: 'no-cache' },
      })
      .then((response) => {
        // console.log(response.data);
        let _result = response.data.sort((a, b) => {
          return b.createdAt - a.createdAt;
        });
        this.setState({ noticeData: _result });
        // console.log('noticeData', this.state.noticeData);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleChange = (panel) => (event, newExpanded) => {
    // console.log(panel);
    // console.log(newExpanded);
    this.setState({ expaneded: newExpanded ? panel : '' });
  };

  render() {
    const { classes } = this.props;
    const noticePopup = (datas) => {
      datas = this.state.noticeData;
      return datas.map((notiCate, i) => {
        return (
          <Accordion key={i} expanded={this.state.expaneded === notiCate.id ? true : false} onChange={this.handleChange(notiCate.id)}>
            <AccordionSummary
              className={classes.listItem}
              expandIcon={
                this.state.expaneded === notiCate.id ? (
                  <ExpandMoreIcon style={{ color: '#f05454' }} />
                ) : (
                  <ExpandMoreIcon style={{ color: '#adadad' }} />
                )
              }
            >
              <Grid container direction="row" justify="flex-start" alignItems="center">
                {/* <div className={classes.listNumber}>{i < 10 ? '0' + (i + 1) : i + 1}.</div> */}
                <Grid item>
                  <Grid container direction="column" justify="flex-start" alignItems="flex-start">
                    <div className={classes.titleDiv}>
                      <p className={classes.listPrimaryMob} style={this.state.expanded === notiCate.id ? { color: '#f05454' } : {}}>
                        {notiCate.title}
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails className={classes.mobResponsive} style={{ backgroundColor: '#f1f1f1' }}>
              <Grid container>
                <div dangerouslySetInnerHTML={{ __html: notiCate.content }} />
              </Grid>
            </AccordionDetails>
          </Accordion>
        );
      });
    };
    return (
      <React.Fragment>
        <Topbar />
        <div className={classes.bg}>
          <Grid item xs={10} className={classes.content_bg}>
            <TitleText title="FAQ" />
            <div style={{ padding: '0 5vw', flex: 1 }}>
              <Grid className={classes.faqOuter}>
                <div style={{ borderTop: '1px solid #f1f1f1' }}>{noticePopup(this.state.noticeData)}</div>
              </Grid>
            </div>
          </Grid>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}
export default withRouter(withStyles(styles)(Faq));
